module.exports = __webpack_public_path__ + "img/savage-banana-soup.2d5069cd.jpg";